import type { TCreditFormCommonFields } from 'entities/creditForm';
import { Phone } from 'entities/creditForm/lib/formatters/base';

export class Contacts {
  // eslint-disable-next-line no-empty-function
  constructor(private readonly data: Pick<Partial<TCreditFormCommonFields>, 'mobilePhone' | 'email'>) {}

  profile() {
    return {
      email: this.data.email,
      mobilePhone: new Phone(this.data.mobilePhone).format(),
    };
  }

  loans() {
    const { email, mobilePhone } = this.profile();

    return {
      mobilePhone: mobilePhone || '',
      email: email || '',
    };
  }
}
